// removed by extract-text-webpack-plugin
module.exports = {"TagListItem":"nu_rQyKlTllocj4lMApQn","pipe":"SURs3R94phdf_7qQx5uY3","checkbox":"_3IQCWqw_r4uLqI8jzt_YxO","label":"_YZFiIsWGlL3ZZchSyG1V"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TagListItem/TagListItem.css
// module id = 386
// module chunks = 8